(() => {
  const SELECTOR = '[data-vl-nav]';

  const initialize = (nav) => {
    if (!nav || nav.dataset.vlNavInit === 'true') return;
    nav.dataset.vlNavInit = 'true';

    const items = [...nav.querySelectorAll('[data-vl-nav-item]')];
    const indicator = nav.querySelector('[data-vl-nav-indicator]');
    let highlighted = null;
    let closeTimer = 0;

    const triggerFor = (item) => item && item.querySelector('[data-vl-nav-target]');
    const detailsFor = (item) => item && item.querySelector('[data-vl-menu]');

    const move = (item) => {
      highlighted = item || null;
      if (!item) {
        nav.style.setProperty('--vl-nav-w', '0px');
        items.forEach((candidate) => candidate.removeAttribute('data-preview'));
        return;
      }
      const target = triggerFor(item);
      if (!target || !indicator) return;
      nav.style.setProperty('--vl-nav-x', `${item.offsetLeft}px`);
      nav.style.setProperty('--vl-nav-w', `${target.offsetWidth}px`);
      items.forEach((candidate) => candidate.toggleAttribute('data-preview', candidate === item));
    };

    const setMenu = (item, open) => {
      const details = detailsFor(item);
      const trigger = triggerFor(item);
      if (!details || !trigger) return;
      details.open = open;
      trigger.setAttribute('aria-expanded', String(open));
    };

    const closeAll = (except = null) => {
      items.forEach((candidate) => {
        if (candidate !== except) setMenu(candidate, false);
      });
    };

    const preview = (item) => {
      window.clearTimeout(closeTimer);
      closeAll(item);
      move(item);
      setMenu(item, true);
    };

    const close = (item) => {
      setMenu(item, false);
      if (highlighted === item) move(null);
    };

    items.forEach((item) => {
      const details = detailsFor(item);
      const trigger = triggerFor(item);

      item.addEventListener('pointerenter', () => preview(item));
      item.addEventListener('pointerleave', () => {
        closeTimer = window.setTimeout(() => close(item), 210);
      });
      item.addEventListener('focusin', () => preview(item));
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) {
          closeTimer = window.setTimeout(() => close(item), 210);
        }
      });

      if (details && trigger) {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
        });
      }
    });

    document.addEventListener('pointerdown', (event) => {
      if (nav.contains(event.target)) return;
      closeAll();
      move(null);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const openItem = items.find((item) => detailsFor(item)?.open);
        const trigger = triggerFor(openItem);
        closeAll();
        move(null);
        if (trigger) {
          trigger.focus();
          closeAll();
          move(null);
        }
      }
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(() => move(highlighted)).observe(nav);
    } else {
      window.addEventListener('resize', () => move(highlighted), { passive: true });
    }

    move(null);
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
